import React from 'react';
import { IconType } from 'react-icons';

interface DetailsBlockProps {
  data: { label: string; value: string; key: string }[];
  title: string;
  Icon: IconType;
}

const DetailsBlock: React.FC<DetailsBlockProps> = ({ data, title, Icon }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="px-8 mb-6">
      <div className="mb-4 text-sm items-center flex-row flex">
        <Icon size={24} className="mr-1" />
        <p className="text-base font-bold">{title}</p>
      </div>
      {data.map((item) => (
        <div className="pb-5" key={item.key}>
          <p className="text-sm font-semibold pb-1">{item.label}</p>
          <p className="text-sm font-normal">{item.value}</p>
        </div>
      ))}
    </div>
  );
};

export default DetailsBlock;
